import { ChangeDetectorRef, inject, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { RegionStore } from '../store/region.store';
import { RegionId } from '../model/region-id.enum';
import { AsyncPipe } from '@angular/common';
import { map } from 'rxjs';

@Pipe({
    name: 'regionName',
    standalone: true,
})
export class RegionNamePipe implements PipeTransform, OnDestroy {
    private readonly _regionStore = inject(RegionStore);
    private readonly _regions$ = this._regionStore.regions$;
    private readonly _cdr = inject(ChangeDetectorRef);
    private readonly asyncPipe = new AsyncPipe(this._cdr);

    transform(value: RegionId) {
        return this._regions$.pipe(map(regions => regions.find(r => r.id === value)?.name));
    }

    ngOnDestroy(): void {
        this.asyncPipe.ngOnDestroy();
    }
}
